module.exports = __webpack_public_path__ + "static/media/Shiploader.1457799b.png";